import { get } from '@Green-Dot-Corporation/eureka-lib-fetch-utils';

export const getAppConfig = async (options) => {
    const config = await get('/appconfig/v1/Config', options);

    return config;
};

export default {};
